// src/components/Footer.js
import React from "react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";

function Footer() {
  const year = new Date().getFullYear();
  const { t } = useTranslation();

  return (
    <footer className="bg-black text-[#DFDFDF] pt-8 mt-auto">
      <div className="flex flex-col items-center mx-auto">
        {/* Logo (centered) */}
        <div className="md:flex-1 md:text-center">
          <span className="font-cinzel-decorative-important text-[36px]">
            O
          </span>
          <span className="font-cinzel-important text-[30px]">PERA</span>
          <span className="font-cinzel-important text-[36px]">T</span>
          <span className="font-cinzel-important text-[30px]">ODAY</span>
          <span className="font-corinthia-important text-[30px]">.org</span>
        </div>
        {/* Three columns */}
        <div className="flex flex-col gap-5 md:flex-row md:justify-around w-full mt-12 max-w-[1360px]">
          {/* Left — INFORMATION */}
          <div className="text-center md:text-left">
            <h3 className="font-cinzel text-[1.2rem] tracking-wide mb-4 text-[#DFDFDF]">
              {t("footer.information")}
            </h3>
            <div className="flex flex-col gap-1">
              <NavLink
                to="/welcome"
                className="text-[#DFDFDF] text-sm no-underline hover:text-white leading-[1.8]"
              >
                {t("footer.welcome")}
              </NavLink>
              {/* <span className="text-[#DFDFDF] text-sm leading-[1.8] cursor-not-allowed">
                {t("footer.contact")}
              </span> */}
              <NavLink
                to="/testimonials"
                className="text-[#DFDFDF] text-sm no-underline hover:text-white leading-[1.8]"
              >
                {t("footer.testimonials")}
              </NavLink>
              <NavLink
                to="/newsletter"
                className="text-[#DFDFDF] text-sm no-underline hover:text-white leading-[1.8]"
              >
                {t("footer.newsletter")}
              </NavLink>
              <NavLink
                to="/FAQs"
                className="text-[#DFDFDF] text-sm no-underline hover:text-white leading-[1.8]"
              >
                {t("footer.faqs")}
              </NavLink>
            </div>
          </div>

          {/* Middle — WRITE TO US */}
          <div className="flex justify-center md:justify-center">
            <div className="text-center md:text-left max-w-[420px]">
              <h3 className="font-cinzel text-[1.2rem] tracking-wide mb-4 text-[#DFDFDF]">
                {t("footer.writeToUs")}
              </h3>
              <div className="flex flex-col gap-1">
                <span className="text-sm leading-[1.8]">
                  {t("footer.yourContact")}
                </span>
                <span className="text-sm leading-[1.8]">
                  {t("footer.email")}:{" "}
                  <a
                    href="mailto:info@operatoday.org"
                    className="text-[#DFDFDF] hover:text-white visited:text-[#DFDFDF]"
                  >
                    info@operatoday.org
                  </a>
                </span>
              </div>
            </div>
          </div>

          {/* Right — LEGAL */}
          <div className="text-center md:text-left">
            <h3 className="font-cinzel text-[1.2rem] tracking-wide mb-4 text-[#DFDFDF]">
              {t("footer.legal")}
            </h3>
            <div className="flex flex-col gap-1">
              <NavLink
                to="/imprint"
                className="text-[#DFDFDF] text-sm no-underline hover:text-white leading-[1.8]"
              >
                {t("footer.imprint")}
              </NavLink>
              <NavLink
                to="/terms-conditions"
                className="text-[#DFDFDF] text-sm no-underline hover:text-white leading-[1.8]"
              >
                {t("footer.termsConditions")}
              </NavLink>
              <NavLink
                to="/travel-cancellation-insurance"
                className="text-[#DFDFDF] text-sm no-underline hover:text-white leading-[1.8]"
              >
                {t("footer.travelCancellationInsurance")}
              </NavLink>
              <NavLink
                to="/image-credits"
                className="text-[#DFDFDF] text-sm no-underline hover:text-white leading-[1.8]"
              >
                {t("footer.imageCredits")}
              </NavLink>
              <NavLink
                to="/privacy-policy"
                className="text-[#DFDFDF] text-sm no-underline hover:text-white leading-[1.8]"
              >
                {t("footer.privacyPolicy")}
              </NavLink>
            </div>
          </div>
        </div>

        {/* White separator */}
        <hr
          className={`!w-full border-t border-[#DFDFDF] my-8 mt-14"
            }`}
        />
        {/* Fine print */}
        <div className="text-center text-md text-[#DFDFDF] mb-2 px-4">
          {t("footer.finePrint")}
          <a href='https://www.opernreisefuehrer.de/' className="hover:text-white"> Opernreiseführer.de</a>
        </div>
        <div className="text-center text-md text-[#DFDFDF] mb-2">
          © {year} {t("footer.copyright")}
        </div>
      </div>
    </footer>
  );
}

export default Footer;
